/// <amd-module name="DistributedTaskUI/SecurityComponent/ProjectPermissionsAuthorization/Actions/ProjectAuthorizationActionsCreator" />
import { ProjectAuthorizationActionsHub } from "ProjectPermissionsAuthorization/Actions/ProjectAuthorizationActionsHub";
import { ProjectAuthorizationSource } from "ProjectPermissionsAuthorization/Source/ProjectAuthorizationSource";
import { ServiceEndpoint, ServiceEndpointProjectReference } from "ServiceEndpoints/Client/Contracts/ServiceEndpoint";
import { TeamProjectReference } from "Tfs/Platform/Contracts/Core";
import * as Resources from "DistributedTaskUI/SecurityComponent/Resources";
import { localeFormat } from "VSS/Core/Util/String";
import * as Utils_Accessibility from "VSS/Core/Util/Accessibility";

export class ProjectAuthorizationActionsCreator {
    constructor(actions: ProjectAuthorizationActionsHub, endpointId: string, source: ProjectAuthorizationSource, updateServiceEndpointSharedFlag: (serviceEndpoint: ServiceEndpoint) => void) {
        this._actionsHub = actions;
        this._source = source;
        this._endpointId = endpointId;
        this._updateServiceEndpointSharedFlag = updateServiceEndpointSharedFlag;
    }

    public initialize(): void {
        this._source.getProjectsData().then((response: TeamProjectReference[]) => {
            this._actionsHub.getProjectsData.invoke(response);
        });
        this._source.getServiceEndpointDetails(this._endpointId).then((response: ServiceEndpoint) => {
            this._actionsHub.getServiceEndpointDetails.invoke(response);
        });
    }

    public deleteProjectReference(serviceendpoint: ServiceEndpoint, projectIds: string[], projectNames: string[]): void {
        let projectName = this.getProjectNameFromProjectNames(projectNames);
        this._source.deleteProjectReference(serviceendpoint, projectIds).then(() => {
            this._source.getServiceEndpointDetails(this._endpointId).then((response: ServiceEndpoint) => {
                this._actionsHub.getServiceEndpointDetails.invoke(response);
                this._updateServiceEndpointSharedFlag(response);
                Utils_Accessibility.announce(localeFormat(Resources.ProjectPermissionsProjectDeletedText, projectName));
            });
        }, (error) => {
            this.setErrorMessage(error.message);
        });
    }

    public addProjectReference(serviceendpoint: ServiceEndpoint, projectReferences: ServiceEndpointProjectReference[]): void {
        let projectName = this.getProjectNameFromProjectReferences(projectReferences);
        this._source.addProjectReference(serviceendpoint, projectReferences).then(() => {
            this._source.getServiceEndpointDetails(this._endpointId).then((response: ServiceEndpoint) => {
                this._actionsHub.getServiceEndpointDetails.invoke(response);
                this._updateServiceEndpointSharedFlag(response);
                Utils_Accessibility.announce(localeFormat(Resources.ProjectPermissionsProjectSharedText, projectName));
            });
        }, (error) => {
            this.setErrorMessage(error.message);
        });
    }

    private getProjectNameFromProjectNames(projectNames: string[]): string {
        let project: string = "";
        projectNames.forEach((projectName: string) => {
            project = project.concat(projectName + " ");
        });
        return project;
    }

    private getProjectNameFromProjectReferences(projectReferences: ServiceEndpointProjectReference[]): string {
        let project: string = "";
        projectReferences.map((projectReference: ServiceEndpointProjectReference) => {
            project = project.concat(projectReference.projectReference.name + " ");
        });
        return project;
    }

    public setErrorMessage(errorMessage: string): void {
        this._actionsHub.setErrorMessage.invoke(errorMessage);
    }

    private _source: ProjectAuthorizationSource;
    private _actionsHub: ProjectAuthorizationActionsHub;
    private _endpointId: string;
    private _updateServiceEndpointSharedFlag: (serviceEndpoint: ServiceEndpoint) => void;
}
